import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "reactstrap";

import { Navbar, NavbarBrand } from "reactstrap";
import Logo from "../Assets/Images/logo.svg";
import userServices from "../UserServices/UserServices";
import { Button } from "antd";
const RTMAdminLayout = () => {
	return (
		<Fragment>
			<Navbar expand="md" className="py-0 shadow flex-nowrap">
				<NavbarBrand>
					<img src={Logo} height="40" alt="SurveyAuto" />
				</NavbarBrand>
				<div className="ml-auto d-flex align-items-center">
					<Button
						style={{ marginRight: "10px" }}
						onClick={() => {
							userServices.signOut();
						}}
					>
						Logout
					</Button>
				</div>
			</Navbar>
			<Container fluid className="main-content-height main-content-overflow">
				<Outlet />
			</Container>
		</Fragment>
	);
};

export default RTMAdminLayout;
